exports = module.exports = require("../../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-onboarding__header .vue-onboarding__header__content{border-radius:5px 5px 0 0;background:#e9ecef;padding:10.5px 16px;color:#212529;border-bottom:1px solid rgba(0,0,0,.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2d3532b8","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/sass-loader@7.3.1_webpack@3.12.0/node_modules/sass-loader/dist/cjs.js!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_lodash@4.18.1_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VueOnboarding/VueOnboardingHeader.vue
// module id = V392
// module chunks = 45